import { Action } from '@ngrx/store';
import { Type } from '@angular/core';

export enum AuthActionsTypes {
  SetAccessUser = '[Auth] access to functionality',
}

export class SetAccessUser implements Action {
  readonly type = AuthActionsTypes.SetAccessUser;
  constructor(public payload: boolean) {}
}

export type AuthActions = SetAccessUser;
